import styled from 'styled-components';

import colors from '@theme/colors';
import checkIcon from '@assets/icons/check-dark.svg';

export const FieldCheckbox = styled.div`
  display: flex;
  align-items: center;
  margin: 2.4rem 0;
`;

export const FieldCheckboxInput = styled.input`
  background-color: transparent;
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
  appearance: none;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  box-shadow: none;
  border-radius: 0px;
  color: ${colors['charcoal']};
  border: ${({ dark }) =>
    dark ? `solid 1px ${colors['egg-shell']}` : `solid 1px ${colors['ash']}`};

  &:focus {
    outline: none;
  }
  &:checked {
    background-color: ${({ dark }) =>
      dark ? colors['egg-shell'] : colors['white']};
    background-image: url(${checkIcon});
    background-size: 1.5rem 1.5rem;
    background-position: center;
  }

  &.ltr {
    margin-right: 1em;
  }
  &.rtl {
    margin-left: 1em;
  }
`;

export const FieldCheckboxLabel = styled.div`
  color: ${({ dark }) => (dark ? colors['beige'] : colors['charcoal'])};
  font-size: 0.9rem;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  padding: 0;
`;
